import React, { ChangeEvent, FormEvent, useState } from "react";
import { toast } from "react-toastify";
import { ResetPwPg } from "./styled";
import topGraphic from "../../assets/top-graphic.png";
import axios from "axios";
import appConfig from "../../config";

const ResetPassword = () => {
  const [email, setEmail] = useState("");

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (email.length) {
      axios
        .get(`${appConfig.API_URL}/users/forget-password`, {
          params: {
            email: email,
          },
        })
        .then(function (response) {
          if (response.data.exist) {
            toast(
              "We have sent you an email to create your new password. Please check your mailbox."
            );
            setEmail("");
          } else {
            toast("This email does not seem to be registered to our system.");
          }
        })
        .catch(function (error) {
          toast(error.response.data.message);
        });
    }
  };

  return (
    <ResetPwPg>
      <img className="top-graphic" src={topGraphic} alt="top graphic" />
      <div className="container pt-4">
        <h5>Reset Password</h5>
        <form className="w-75" onSubmit={handleSubmit}>
          <div className="py-2">
            <label htmlFor="email">Email*</label>
          </div>
          <div className="py-2">
            <input
              type="email"
              placeholder="Enter Your Email"
              onChange={handleChange}
              value={email}
            />
          </div>
          <div className="py-3">
            <button className="btn btn-danger">Reset Password</button>
          </div>
          <p className="pt-4">
            Check your email and follow the instructions to reset your password.
          </p>
        </form>
      </div>
    </ResetPwPg>
  );
};

export default ResetPassword;
